import { useState } from 'react';
import { useWorksheetSample } from './useWorksheetSample';
import { failingRowsFocus } from './worksheetValidations';

/**
 * What a Worksheet's grid shows of its Result: the rows failing the
 * Validation picked in its summary, else its Sample.
 */
export function useWorksheetResultView(
  input: Parameters<typeof useWorksheetSample>[0],
) {
  const sample = useWorksheetSample(input);
  const [picked, pick] = useState<string | null>(null);
  const failing = failingRowsFocus(input.sheet, input.result, picked);
  return {
    sample,
    /** The Validation whose failing rows the grid shows, if it has any to show. */
    failingId: failing ? picked : null,
    failing,
    showFailing: pick,
    focus: failing ?? sample.focus,
  };
}

export type WorksheetResultView = ReturnType<typeof useWorksheetResultView>;
